module.exports = __webpack_public_path__ + "static/img/joinus.42b947e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/joinus.jpg
// module id = Y6SM
// module chunks = 1